import api from '@/api'

export default {
  all: (filter) => api('get', '/product', filter),
  create: (data) => api('post', '/product', data),
  show: (id) => api('get', `/product/${id}`),
  delete: (id) => api('delete', `/product/${id}`),
  update: (data) => api('put', `/product/${data.id}`, data),
  upload: (data) => api('post', '/product/upload', data)
}
